// Единая карточка документа для «Центра документов» (/admin/documents).
//
// Один и тот же каркас для всех типов документов (паспорта, упаковочный лист,
// протокол испытаний), чтобы кнопки формирования/печати выглядели и вели себя
// одинаково независимо от типа. Контент действий передаётся через children.

import type { ReactNode } from "react";

export function DocumentCard({
  icon,
  title,
  description,
  status,
  children,
  muted = false,
}: {
  icon: string;
  title: string;
  description: string;
  /** Короткий статус-бейдж/строка справа от заголовка. */
  status?: ReactNode;
  /** Ряд кнопок действий (одинаковый набор: сформировать/печать/история). */
  children: ReactNode;
  /** Приглушённый вид, когда документ в этом контексте недоступен. */
  muted?: boolean;
}) {
  return (
    <section
      className={`card p-5 space-y-3 ${muted ? "opacity-70" : ""}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <span className="text-2xl leading-none" aria-hidden>
            {icon}
          </span>
          <div>
            <h3 className="text-base font-medium">{title}</h3>
            <p className="text-sm text-text-muted mt-0.5">{description}</p>
          </div>
        </div>
        {status != null && <div className="shrink-0">{status}</div>}
      </div>
      <div className="flex flex-wrap items-center gap-2 pt-1">{children}</div>
    </section>
  );
}
